<template>
  <div>
    <form @submit.prevent="validate" v-if="isUpdate()">
      <div class="row">
        <div class="col-12 col-xl-6">
          <fg-input
            type="text"
            :label="`${$t('labor.worker')}: `"
            :value="`${model.header.worker.first_name} ${model.header.worker.last_name}`"
            readonly
          >
          </fg-input>
        </div>
        <div class="col-12 col-xl-6">
          <fg-input
            type="text"
            :label="`${$t('common_words.position')}: `"
            :value="`${model.header.worker.job_name}`"
            readonly
          >
          </fg-input>
        </div>
      </div>
      <div class="row">
        <select-component
          :dataOptions="farms"
          :isMultiple="false"
          :rowClass="`${
            getActivity && getActivity.catch_type === 'lote'
              ? `col-6`
              : `col-12`
          }`"
          :selectedInitial="model.header.farm_id"
          @onChange="handleChangeSelected"
          :labelSelect="`${$t('common_words.name')}: *`"
          modelName="header.farm_id"
          requireClass="required-farms"
        />
        <select-component
          v-if="getActivity && getActivity.catch_type === 'lote'"
          :dataOptions="lots"
          :isMultiple="false"
          :selectedInitial="model.lot_id"
          @onChange="handleChangeSelected"
          :labelSelect="`${$t('common_words.allotment')}: *`"
          modelName="lot_id"
          requireClass="required-lots"
          rowClass="col-6"
        />
      </div>
      <div class="row">
        <select-component
          :dataOptions="activities"
          :isMultiple="false"
          :selectedInitial="model.activity_id"
          @onChange="handleChangeSelected"
          :labelSelect="`${$t('common_words.activity')}: *`"
          modelName="activity_id"
          requireClass="required-activity"
          rowClass="col-12"
        />
      </div>
      <div class="row" v-if="getActivity">
        <div class="col-12 col-xl-6">
          <fg-input
            type="text"
            :label="`${$t('common_words.category_or_group')}: *`"
            :value="`${getGroupName}`"
            readonly
          >
          </fg-input>
        </div>
        <div class="col-12 col-xl-6">
          <fg-input
            type="text"
            :label="`${$t('labor.unit_of_payment')}: *`"
            :value="`${getActivity.activity_unit_payment.name} (${getActivity.activity_unit_payment.abbreviation})`"
            readonly
          >
          </fg-input>
        </div>
      </div>
      <div class="row">
        <select-component
          :dataOptions="timetypes"
          :isMultiple="false"
          :selectedInitial="model.time_type_id"
          @onChange="handleChangeSelected"
          :labelSelect="`${$t('common_words.shift_type')}: *`"
          modelName="time_type_id"
          requireClass="required-journal"
          rowClass="col-12 col-xl-4"
        />
        <div class="col-12 col-xl-4">
          <fg-input
            type="number"
            :step="
              getActivity &&
              getActivity.activity_unit_payment.data_formate === 'Decimal'
                ? '.01'
                : null
            "
            :label="`${$t('common_words.quantity')}: *`"
            v-model="model.quantity"
            name="common_words.quantity"
            v-validate="modelValidations.quantity"
            :error="getError('common_words.quantity', true)"
          >
          </fg-input>
        </div>
        <div class="col-12 col-xl-4">
          <fg-input
            type="number"
            :label="`${$t('labor.h_number')}: *`"
            v-model="model.number_hours"
            name="labor.hour_numbers"
            v-validate="modelValidations.number_hours"
            :error="getError('labor.hour_numbers', true)"
          >
          </fg-input>
        </div>
        <div class="col-12 col-xl-6">
          <fg-input
            type="text"
            :label="`${$t('common_words.order_service')}: `"
            v-model="model.service_order"
          >
          </fg-input>
        </div>
        <div class="col-12">
          <div class="form-group has-label">
            <label>{{ $t('common_words.observation') }}: </label>
            <br />
            <el-input
              maxlength="300"
              show-word-limit
              type="textarea"
              :rows="3"
              :placeholder="$t('common_words.the_threepoints')"
              v-model="model.observations"
              class="shadow-sm"
            ></el-input>
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-12 text-right">
          <button type="submit" class="btn btn-fill btn-info btn-wd shadow-sm">
            {{ $t('common_words.edit') }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import MixinFarm from 'src/util/mixinFarm';
import Select from 'src/components/Selects/Select';

export default {
  components: {
    [Select.name]: Select,
  },
  name: 'job-editing-form',
  props: {
    detail: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    getActivity() {
      const activitySelected = this.activities.find(
        (activity) => activity.id === this.model.activity_id
      );
      return activitySelected;
    },

    getGroupName() {
      const activitySelected = this.getActivity;
      return activitySelected ? activitySelected.group_name : '';
    },
  },
  data() {
    return {
      model: {
        header: {
          worker: {
            first_name: '',
            last_name: '',
          },
          farm_id: null,
        },
        time_type: null,
        activity: {
          activity_unit_payment: {
            abbreviation: '',
          },
          unit_payment_name: '',
          group_name: '',
          catch_type: null,
        },
        activity_id: null,
        lot_id: null,
        time_type_id: null,
        quantity: null,
        number_hours: null,
        service_order: null,
        observations: '',
      },
      modelValidations: {
        quantity: {
          required: true,
        },
        number_hours: {
          required: true,
        },
      },
      activities: [],
      farms: [],
      lots: [],
      timetypes: [],
    };
  },
  mixins: [MixinPermissions, MixinFarm, MixinValidations],
  watch: {
    detail(value) {
      this.model = { ...value };
      this.loadInitialData();
    },
  },
  methods: {
    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.header.farm_id)) {
            return this.validationInputsRequired('farms');
          } else if (!isset(this.model.activity_id)) {
            return this.validationInputsRequired('activity');
          } else if (!isset(this.model.time_type_id)) {
            return this.validationInputsRequired('journal');
          }
        }
        if (this.isUpdate()) {
          this.$emit('showHideLoading', true);
          this.model.route = 'works/labordetails';
          Axios.updateMaster(this.model)
            .then((response) => {
              this.$emit('updateRow', response);
              this.$emit('closeModal', 'read');
              this.$emit('showHideLoading', false);
            })
            .catch((error) => {
              this.$emit('showHideLoading', false);
              this.$emit('showMessageErrors', error);
            });
        }
      });
    },

    handleChangeSelected(data) {
      switch (data.name) {
        case 'header.farm_id':
          this.$set(this.model.header, 'farm_id', data.selects);
          this.getLots(this.getActivity ? this.getActivity.catch_type : null);
          this.model.lot_id = null;
          break;
        case 'activity_id':
          this.getLots(this.getActivity ? this.getActivity.catch_type : null);
          this.$set(this.model, data.name, data.selects);
          break;
        default:
          this.$set(this.model, data.name, data.selects);
          break;
      }
    },

    async getLots(catchType) {
      if (catchType && catchType === 'lote') {
        this.$emit('showHideLoading', true);
        const allLots = await this.getLotsByFarm(
          [this.model.header.farm_id],
          this.farms
        );
        this.$emit('showHideLoading', false);
        this.lots = allLots;
      }
    },

    loadInitialData() {
      this.$emit('showHideLoading', true);
      Promise.all([
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('works/timetypes/field'),
        Axios.getMasters('works/activities/field'),
      ]).then((response) => {
        const [response_farms, response_timetypes, response_activities] =
          response;
        this.farms = response_farms.data.data;
        this.timetypes = response_timetypes.data.data;
        this.activities = response_activities.data.data;
        this.$emit('showHideLoading', false);
        this.getLots(this.getActivity ? this.getActivity.catch_type : null);
      });
    },
  },
  mounted() {
    this.model = { ...this.detail };
    if (this.isIndex()) {
      this.loadInitialData();
    }
  },
};
</script>
